<template>
  <Modal v-if="value" :enableFooter="false" @close="close()">
    <template v-slot:header>
      <div></div>
    </template>
    <template v-slot:body>
      <v-col cols="12">
        <div class="card mt-5">
          <div class="card-header border-0 pt-5">
            <div class="card-toolbar">
              <ul class="nav">
                <li class="nav-item">
                  <a
                    class="
                      nav-link
                      btn btn-sm btn-color-muted btn-active btn-active-dark
                      fw-bolder
                      px-4
                      me-1
                    "
                    :class="{ active: selectedTab == adminTab }"
                    @click="selectedTab = adminTab"
                    >Subscribe a Worker</a
                  >
                </li>
                <!-- <li class="nav-item">
                  <a
                    class="
                      nav-link
                      btn btn-sm btn-color-muted btn-active btn-active-dark
                      fw-bolder
                      px-4
                    "
                    :class="{ active: selectedTab == emailTab }"
                    @click="selectedTab = emailTab"
                    >Subscribe an Email Address</a
                  >
                </li> -->
              </ul>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body py-3">
            <div class="tab-content">
              <!--begin::Tap pane-->
              <div
                class="tab-pane show active"
                id="kt_table_widget_5_tab_1"
                name="Items Tab"
                v-if="selectedTab == adminTab"
              >
                <AddSubscriberWorker @addSubscriber="addSubscriber" :workers="workers" :subscribers="subscribers" />
              </div>
              <!--end::Tap pane-->
              <!--begin::Tap pane-->
              <div
                class="tab-pane show active"
                id="kt_table_widget_5_tab_2"
                name="Barrel History"
                v-if="selectedTab == emailTab"
              >
                EMAIL TAB
              </div>
              <!--end::Tap pane-->
            </div>
          </div>
          <!--end::Body-->
        </div>
      </v-col>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import AddSubscriberWorker from "@/components/AddSubscriberWorker.vue"

export default {
  name: "AddSubscriber",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    subscribers: {
      type: Array,
      default: [],
    },
    workers: {
        type: Array,
        default: []
    }
  },
  components: {
    Modal,
    AddSubscriberWorker
  },
  data() {
    return {
        selectedTab: "adminTab",
        adminTab: "adminTab",
        emailTab: "emailTab"
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    addSubscriber(payload){
        this.$emit("addSubscriber", payload);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>